<template>
  <div class="c-gift-box">
    <div class="gift__img" :style="`background-image: url(${data.imgPath})`" />
    <p class="gift__title">{{ data.title }}</p>
    <p class="gift__desc">{{ data.desc }}</p>

  </div>
</template>
<script>
import { defineComponent } from 'vue';
import previewImg from '@/assets/img/global/img_preview.jpg';

export default defineComponent({
  name: 'GiftBox',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const baseUrl = process.env.VUE_APP_BASE_URL;
    const coverImageSrc = props.data.path ? `${baseUrl}/${props.data.path}` : previewImg;

    return {
      coverImageSrc,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-gift-box {
  width: 100%;
  display: flex;
flex-direction: column;
}

.gift {
  &__img {
    width: 100%;
    padding-top: 67%;
    background-size: cover;
    background-position: 50% 50%;
    border-radius: 20px;
  }

  &__title {
    white-space: normal;
    margin-top: 20px;;
    @include font-important();
  }

  &__desc {
    margin-top: 30px;
    @include font-normal();

  }
}

</style>
